import { Card, Col, Row, Typography } from 'antd';
import { Link } from 'react-router-dom';
import {
  ApartmentOutlined,
  ProfileOutlined,
  ShoppingCartOutlined,
  TeamOutlined,
  UserOutlined,
} from '@ant-design/icons';

const { Title, Text } = Typography;

const features = [
  {
    icon: <ProfileOutlined style={{ fontSize: 32, color: '#1677ff' }} />,
    title: 'Employee Programs',
    description: 'Manage employee benefit programs, investment plans and vesting.',
    href: '/futureflex/employee-programs',
  },
  {
    icon: <ShoppingCartOutlined style={{ fontSize: 32, color: '#1677ff' }} />,
    title: 'Program Orders',
    description: 'Generate, bundle, rebundle and continue program orders.',
    href: '/futureflex/program-orders',
  },
  {
    icon: <ApartmentOutlined style={{ fontSize: 32, color: '#1677ff' }} />,
    title: 'Companies',
    description: 'Companies, portfolios and redistribution funds.',
    href: '/futureflex/companies',
  },
  {
    icon: <UserOutlined style={{ fontSize: 32, color: '#1677ff' }} />,
    title: 'Employees',
    description: 'Employees enrolled in company programs.',
    href: '/futureflex/employees',
  },
  {
    icon: <TeamOutlined style={{ fontSize: 32, color: '#1677ff' }} />,
    title: 'HR Admin',
    description: 'Company HR staff accounts.',
    href: '/futureflex/staffs',
  },
];

export default function FutureFlexHomePage() {
  return (
    <div style={{ padding: 32 }}>
      <Title level={2}>FutureFlex</Title>
      <Text type="secondary" style={{ display: 'block', marginBottom: 32 }}>
        B2B employee benefit programs — companies, employees and program orders.
      </Text>

      <Row gutter={[24, 24]}>
        {features.map(feature => (
          <Col xs={24} sm={12} lg={6} key={feature.href}>
            <Link to={feature.href}>
              <Card
                hoverable
                style={{ height: '100%' }}
                styles={{ body: { display: 'flex', flexDirection: 'column', gap: 12 } }}
              >
                {feature.icon}
                <Title level={5} style={{ margin: 0 }}>{feature.title}</Title>
                <Text type="secondary">{feature.description}</Text>
              </Card>
            </Link>
          </Col>
        ))}
      </Row>
    </div>
  );
}
